import styled from 'styled-components';
import theme from '../../styles/theme';

export const _Sidebar = styled.div`
  position: fixed;
  top: 55px;
  bottom: 0;
  left: 0;
  width: 358px;
  background: #fff;
  border-right: 2px solid #eaeaea;
  box-sizing: border-box;
  color: rgba(255,255,255,0.9);
  display: flex;
  z-index: 5;
`

export const _ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #43463f;
  max-width: 290px;
`

export const _Slider = styled.div`
  margin: 2px 0;
  div {
    margin: 0 !important;
  }
`

export const _Label = styled.label`
  font-size: 12px;
  font-weight: bold;
  display: block;
  color: #a2a99c;
`

export const _Field = styled.div`
  margin-bottom: 12px;
`

export const _Heading = styled.div`
  font-size: 15px;
  text-transform: uppercase;
`

export const _Paragraph = styled.p`
  font-size: 13px;
  color: #a2a99c;
  margin-top: 0px;
  line-height: 1.4;
`

export const _MenuBar = styled.div`
  width: 70px;
  height: 100%;
  background: ${props => props.color};
  position: relative;
`

export const _MenuButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70px;
  font-size: 8px;
  text-transform: uppercase;
  color: rgba(255,255,255,0.6);
  cursor: pointer;
  &:hover {
    color: rgba(255,255,255,0.9);
  }
  ${props => props.selected && 'color: rgba(255,255,255,0.9)'};
  position: relative;
  z-index: 10;
  svg {
    margin-bottom: 2px;
    font-size: 30px;
  }
  padding: 0 5px;
  text-align: center;
`

export const StyledPreview = styled.div`
  text-align: center;
  
  padding: 20px;
  margin: 10px;
  
  margin-bottom: 5px;
  cursor: pointer;
  border-radius: 5px;
  &:hover {
    background: rgba(255,255,255,0.1);
  }
`

export const _TextButton = styled.span`
  &:hover {
    color: #fff;
    cursor: pointer;
  }
`


// WEBPACK FOOTER //
// ./src/components/menu/styled-sidebar.js